import { render, staticRenderFns } from "./AbkSurveyTextSvg.vue?vue&type=template&id=20f49077&scoped=true&"
import script from "./AbkSurveyTextSvg.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyTextSvg.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyTextSvg.vue?vue&type=style&index=0&id=20f49077&lang=scss&scoped=true&"
import style1 from "./AbkSurveyTextSvg.vue?vue&type=style&index=1&id=20f49077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f49077",
  null
  
)

export default component.exports